function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React, { useRef } from "react";
import { useLayoutEffect } from "../../hooks/useLayoutEffect";
import useForceUpdate from "../../hooks/useForceUpdate";
import getOwnerDocument from "../../utils/getOwnerDocument";
import { createPortal } from "react-dom";
import { isRefObject } from "../../utils/is/is";
import { injectTestId } from "@cvent/nucleus-test-automation";
export var Portal = function(param1) {
    var children = param1.children, portal = param1.portal, testID = param1.testID;
    var mountRef = useRef(null);
    var portalRef = useRef(null);
    var hasPortal = !!portal;
    var forceUpdate = useForceUpdate();
    useLayoutEffect(function() {
        if (!portal || !hasPortal || !mountRef.current || isRefObject(portal)) {
            return;
        }
        var ownerDocument = getOwnerDocument(mountRef.current);
        if (ownerDocument === null) {
            return;
        }
        var existingPortal;
        if (portal === true) {
            existingPortal = ownerDocument.getElementById('carina-portal-root');
        } else if (typeof portal === 'string') {
            existingPortal = ownerDocument.getElementById(portal);
        } else {
            existingPortal = portal;
        }
        if (existingPortal) {
            portalRef.current = existingPortal;
        } else {
            portalRef.current = ownerDocument.createElement('div');
            portalRef.current.setAttribute('id', typeof portal === 'string' ? portal : 'carina-portal-root');
            Object.entries(injectTestId(testID)).forEach(function(param) {
                var _param = _slicedToArray(param, 2), key = _param[0], value = _param[1];
                var ref;
                (ref = portalRef.current) === null || ref === void 0 ? void 0 : ref.setAttribute(key, value);
            });
            ownerDocument.body.appendChild(portalRef.current);
        }
        forceUpdate();
    }, [
        hasPortal,
        forceUpdate,
        portal,
        testID
    ]);
    if (hasPortal) {
        if (isRefObject(portal) && _instanceof(portal.current, HTMLElement)) {
            return createPortal(children, portal.current);
        }
        return portalRef.current ? createPortal(children, portalRef.current) : _jsx("span", {
            ref: mountRef
        });
    }
    return children;
};
export default Portal;
